import { IGlobalStore } from 'modules/types';


export const getFooterData = ( state: IGlobalStore ) => state.footer;